<template>
	<main id="subPage" class="admin">
		<!-- 카테고리 -->
        <section id="category">
			<h2>관리자 메뉴</h2>
			<ul class="breadCrumb">
				<li class="home"></li>
				<li class="web">
					<p class="pageTxt">관리자 메뉴</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
						<li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
					</ul> 
				</li>
                <li class="web">
					<p class="pageTxt">할인차량관리</p>
					<ul class="depth">
						<li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
						<li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
						<li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
                        <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
						<li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
					</ul> 
				</li>
                <li>
					<p class="pageTxt">무료차량 관리</p>
					<ul class="depth">
						<li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
						<li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
					</ul> 
				</li>
			</ul>
        </section>

		<!-- 컨텐츠 영역 -->
		<section id="content">
			<div class="inner">
				<h3 class="pageTitle">무료차량 수정</h3>
                <article>
                    <!--table-->
                    <div class="table horizontal-table">
                        <table>
                            <caption>무료차량 수정 테이블</caption>
                            <colgroup>
                                <col style="width:15%; min-width: 60px;"/>
                                <col style="width:auto"/>
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th scope="row">사용자명</th>
                                    <td>
                                        <input type="text" title="사용자명 입력" class="md" v-model="carOwnerNm">
                                        <div class="error" v-if="!$v.carOwnerNm.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">차량번호</th>
                                    <td>
                                        <div class="flex">
                                            <input type="text" title="사용자명 입력" class="md" v-model="carNo">
                                            <button type="button" @click="duplicateCheck" class="btn gray">중복확인</button>
                                        </div>
                                        <div class="error" v-if="!$v.carNo.required">필수 입력란입니다.</div>
                                        <div class="error" v-if="!$v.carNo.carNoCheck">차량번호 형식에 맞지 않습니다.</div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">무료유형</th>
                                    <td>
                                        <select v-model="fctCode" name="" id="" class="md">
                                            <option v-for="(item, index) in fctCodeList" :key="index"
                                                :value="item.code.code">{{ item.code.codeNm }}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">대상 주차장</th>
                                    <td>
                                        <select v-model="sectnId" title="대상 주차장 선택" class="md">
                                            <option v-for="parking in parkingList" :key="parking.SECTN_ID" :value="parking.SECTN_ID">{{parking.PARKING_NM}}</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">소속</th>
                                    <td>
                                        <div class="flex">
                                            <input v-model="orgNm" type="text" class="md">
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">적용요일</th>
                                    <td>
                                        <v-card flat>
                                        <v-card-text>
                                        <v-container fluid>
                                        <v-row>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="일"
                                        value="1"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="월"
                                        value="2"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="화"
                                        value="3"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="수"
                                        value="4"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="목"
                                        value="5"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="금"
                                        value="6"
                                        ></v-checkbox>
                                        <v-checkbox
                                        v-model="applyDay"
                                        label="토"
                                        value="7"
                                        ></v-checkbox>
                                            </v-row>
                                    </v-container>
                                </v-card-text>
                                </v-card>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">무료기간</th>
                                    <td>
                                        <date-picker :propsDate="propsDateArr" @emitSetDate="emitSetDate"></date-picker>
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">비고</th>
                                    <td>
                                        <input type="text" title="비고 입력" v-model="freeNote">
                                        <div class="error" v-if="!$v.freeNote.required">필수 입력란입니다.</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--//table-->

                </article>
                <article class="btnArea">
                    <button type="button" class="btn border" @click="$router.push('freevehicle')">목록</button>
                    <button type="button" class="btn gray" @click="$router.push('freevehicle')">취소</button>
                    <button type="button" class="btn blue" @click="updateBtn">저장</button>
                </article>
            </div>
        </section>
	</main>
</template>

<script>
import axios from "../../../util/axios";
import DatePicker from '../../../components/DatePicker2.vue';
import { required, helpers, or } from 'vuelidate/lib/validators'
const carNoRegex     = helpers.regex('carNoRegex', /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegexDipl = helpers.regex('carNoRegexDipl', /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi);

export default {
	data(){
		return{
            orgNm         : '',
			carNo         : '',
			endDt         : '',
			sectnId       : '',
			startDt       : '',
			freeNote      : '',
			freeCarId     : '',
            fctCode       : '',
			carOwnerNm    : '',
			parkingList   : [],
            fctCodeList   : [],
			submitStatus  : '',
			propsDateArr  : [],
            parkingRegDiv : '',
            applyDay: [],
		}
    },

    validations: {
		carOwnerNm: {
			required
		},
		orgNm: {
			required
		},
		carNo: {
			required,
			carNoCheck: or(carNoRegex, carNoRegexDipl)
		},
		sectnId: {
			required
		},
		freeNote: {
			required
		}
	},

	components:{
        DatePicker,
	},
	
	mounted(){
        const data = this.$route.params.data;
        if(!data) {
			alert("잘못된 접근입니다.");
            this.$router.push('/freevehicle');
            return;
        }
        this.freeCarId = data.freeCarId;
		this.carOwnerNm = data.carOwnerNm;
		this.orgNm = data.orgNm;
		this.carNo = data.carNo;
		this.sectnId = data.sectnId;
		this.startDt = data.startDt;
		this.endDt = data.endDt;
		this.freeNote = data.freeNote;
        this.fctCode = data.fctCode;
        this.parkingRegDiv = data.parkingRegDiv;
        for(let i=0;i<data.applyDay.toString().length;i++) {
            switch (data.applyDay.toString().slice(i,i+1)) {
                case '1':
                    this.applyDay.push('1');
                    break;
                case '2':
                    this.applyDay.push('2');
                    break;
                case '3':
                    this.applyDay.push('3');
                    break;
                case '4':
                    this.applyDay.push('4');
                    break;
                case '5':
                    this.applyDay.push('5');
                    break;
                case '6':
                    this.applyDay.push('6');
                    break;
                case '7':
                    this.applyDay.push('7');
                    break;
            }
        }
        if(this.parkingRegDiv == 'PRD-002') {
            this.sectnId = -1;
        }
		this.propsDateArr = {
			startDate: this.startDt,
			endDate: this.endDt
		};
        this.init();
	},

    methods: {
        async init() {
            const urls = ["/api/parking/map.json","/api/admin/freecar/fctCode.json"]
            const req = urls.map(url => axios('get', url));
            const res = await Promise.all(req);
            const [parkingList, fctCodeList] = await Promise.all(res);
            this.parkingList = parkingList.data.parkingMapList;
            this.fctCodeList = fctCodeList.data.fctCodeList.result;
            this.parkingList.unshift({PARKING_NM:'부설 주차장(가산금 없는 주차장)', SECTN_ID:null});
            this.parkingList.unshift({PARKING_NM:'전체', SECTN_ID:-1});
        },

        emitSetDate(startDate, endDate) {
            this.propsDateArr.startDate = startDate;
            this.propsDateArr.endDate = endDate;
        },

        async updateBtn() {

            this.duplicateCheck();

            let applyDay = '';
            for (const i of this.applyDay) {
                applyDay += i
            }
            const apiParams = new FormData();
            apiParams.append("freeCarId", this.freeCarId);
            apiParams.append('carOwnerNm', this.carOwnerNm);
            apiParams.append('carNo', this.carNo.replace(/ /gi, ''));
            apiParams.append('freeNote', this.freeNote);
            apiParams.append('applyDay',applyDay);
            apiParams.append('fctCode', this.fctCode);
            apiParams.append('startDtString', this.propsDateArr.startDate);
            apiParams.append('endDtString', this.propsDateArr.endDate);
            apiParams.append('orgNm', this.orgNm);  
            if(this.sectnId == -1) {
                apiParams.append('parkingRegDiv', 'PRD-002');
            }else if(this.sectnId == null){
                apiParams.append('parkingRegDiv', 'PRD-003');
            }else {
                apiParams.append('sectnId', this.sectnId);
                apiParams.append('parkingRegDiv', 'PRD-001');
            }
            const res = await axios('post', "/api/admin/freecar/updateAction.json", apiParams);
            if(res.data?.resultMap?.code == '00') {
                this.$router.push('freevehicle');
            }else {
                alert('다시 시도해주세요');
            }
        },

        async duplicateCheck() {
            if ( this.$route.params.data.carNo == this.carNo ) {
                alert('같은 번호입니다.');
                return;
            }
            if (!this.$v.carNo.carNoCheck || this.carNo == '') {
                alert('차량 형식에 맞게 입력해주세요.');
                return;
            }
            if(this.sectnId == '') {
                alert('주차장 선택 후 확인해주세요.');
                return;
            }
            const apiParams = new FormData();
            apiParams.append('carNo', this.carNo.replace(/ /gi, ''));
            apiParams.append('sectnId', this.sectnId);
            const res = await axios('post', '/api/admin/freecar/carNoCheck.json', apiParams);
            const data = res.data?.hashMap?.result?.result;
            if (data) {
                this.dupChk = true;
                alert('등록 가능한 차량입니다.');
            } else {
                alert('이미 등록중인 차량입니다.');
            }
        },
	},
}
</script>

